export interface HomepageFeatureCard {
  icon: string
  title: string
  description: string
}

export const DEFAULT_HOMEPAGE_FEATURE_CARDS: HomepageFeatureCard[] = [
  {
    icon: 'i-heroicons-truck',
    title: 'Livrare rapidă',
    description: 'Livrare rapidă în toată România.',
  },
  {
    icon: 'i-heroicons-shield-check',
    title: 'Garanție inclusă',
    description: 'Produsele beneficiază de garanție conform legii.',
  },
  {
    icon: 'i-heroicons-chat-bubble-left-right',
    title: 'Suport clienți',
    description: 'Echipa noastră te ajută înainte și după comandă.',
  },
]

export function parseHomepageFeatureCards(
  raw?: string | null,
  fallback: HomepageFeatureCard[] = DEFAULT_HOMEPAGE_FEATURE_CARDS,
): HomepageFeatureCard[] {
  if (!raw) return [...fallback]
  try {
    const parsed = JSON.parse(raw) as HomepageFeatureCard[]
    if (!Array.isArray(parsed)) return [...fallback]
    return parsed
      .filter((item) => item.title?.trim() && item.description?.trim())
      .map((item) => ({
        icon: item.icon?.trim() || 'i-heroicons-sparkles',
        title: item.title.trim(),
        description: item.description.trim(),
      }))
  } catch {
    return [...fallback]
  }
}
